import { Location } from "history";
import { SegmentApi } from "go-segment/services/types";

export const getDocumentActiveSegmentSlug = (location: Location) => {
	return new URLSearchParams(location.search).get("s");
};

export const findDocumentActiveSegment = (segments: SegmentApi[], location: Location) => {
	const slug = getDocumentActiveSegmentSlug(location);

	return segments.find((segment) => segment.slug === slug);
};
